import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../types";
import { useAppData } from "./useAppData";

export const useSelectedTenant = () => {
  // We are reading appData from state with shallowEqual comparer - therefore it's safe to disable react-hooks/exhaustive-deps check here
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tenants = useAppData((x) => x.tenants) ?? [];
  let selectedTenantInfo = useSelector((x: AppState) => x.tenant);
  const selectedTenant = useMemo(() => {
    if (selectedTenantInfo.tenantId) {
      if (!tenants.find((x) => x.id === selectedTenantInfo.tenantId)) {
        return { tenantId: null };
      }
    }

    return selectedTenantInfo;
  }, [selectedTenantInfo, tenants]);
  return selectedTenant;
};
